<template>
    <div class="container">
        <div class="banner">
            <!-- <img :src="config.applyTemplateImg" alt="" /> -->
            <div class="title">
                <span class="price" v-if="sourceType === 'machine'">向TA询价</span>
                <span class="price" v-else>向TA咨询</span>
                <span class="person-info">提交个人信息，享受一对一服务</span>
            </div>

        </div>
        <div class="content">
            <div class="guide-box">
                <template v-if="!isCatchGuide">
                    <div class="guide-img">
                        <img :src="guideInfo.avatar" alt="" class="avatar">
                    </div>
                    <div class="guide-right">
                        <div class="guide-name">服务顾问：{{ guideInfo.guideName || '--' }}</div>
                        <div class="guide-address">{{ guideInfo.networkName + guideInfo.networkAddress || '--' }}</div>
                    </div>
                </template>
                <template v-else>
                    <img :src="guideInfo.qrCodeUrl || 'https://market-cdn.anoah.com/dm/static/market-h5-smartguide/guide_code_error.png'"
                        alt="" class="guide-qrcode">
                    <div class="guide-right">
                        <div class="guide-name">咨询电话：{{ guideInfo.guidePhone || '--' }}</div>
                        <div class="guide-address">关注公众号，联系我们</div>
                    </div>
                </template>
            </div>
            <van-cell-group>
                <van-cell>
                    <template #title>
                        <van-field class="name-input" @focus="getFocus('name')" maxlength="20" v-model.trim="name"
                            label-width="88" autofocus @blur.native.capture="nameValidateAction"
                            :error-message="nameValidate" placeholder="请输入您的姓名"><template #label>
                                <div class="label-box">
                                    <span class="label">姓 名</span>
                                </div>

                            </template>
                        </van-field>
                    </template>
                    <template #right-icon>
                        <van-radio-group v-model="sexCode" direction="horizontal" @change="btnClick('sex', $event)">
                            <van-radio class="six-radio radio" :name="1">先生
                                <template #icon="props">
                                    <img class="radio-icon" :src="requireIcon(props)" />
                                </template>
                            </van-radio>
                            <van-radio class="six-radio radio" :name="2">女士
                                <template #icon="props">
                                    <img class="radio-icon" :src="requireIcon(props)" />
                                </template>
                            </van-radio>
                        </van-radio-group>
                    </template>
                </van-cell>
            </van-cell-group>
            <van-cell-group>
                <van-field v-model.trim="phone" label-width="88" type="tel" placeholder="请输入11位的手机号码"
                    @focus="getFocus('phone')" @blur.native.capture="phoneValidateAction"
                    :error-message="phoneValidate">
                    <template #label>
                        <span class="label">联系电话</span>
                    </template>
                </van-field>
            </van-cell-group>
            <van-cell-group>
                <van-cell>
                    <template #title>
                        <van-field class="name-input" v-model.trim="verifyCode" label-width="88" type="digit"
                            maxlength="6" placeholder="请输入验证码" @focus="getFocus('code')"
                            @blur.native.capture="codeValidateAction" :error-message="codeValidate">
                            <template #label>
                                <span class="label">验证码</span>
                            </template>
                        </van-field>
                    </template>
                    <template #right-icon direction="horizontal">
                        <span class="verify-code" @click="getVerifyCode">{{ codeBtnText }}</span>
                    </template>
                </van-cell>
            </van-cell-group>
        </div>
        <div class="empty-placeholder"></div>
        <div class="bottom-text">
            <div class="agree-statement">
                <van-checkbox v-model="checked" @change="btnClick('check', $event)" shape="square"> </van-checkbox>
                <span>我同意</span>
                <span class="person-statement" @click="openLink">《个人信息保护声明》</span>
            </div>
            <div class="submit-wrapper">
                <van-button @click="onSubmit" class="submit" :color="canSubmit ? '#FFD451' : '#E9E9ED'"
                    type="primary">立刻询价</van-button>
            </div>
            <span class="desc">点击立刻询价后服务顾问将与你提交的手机号进行联系</span>
        </div>
    </div>
</template>

<script>
import {
    map,
    prop,
    flow,
    join,
    isEmpty,
    last,
    first,
    findIndex,
    find,
    replace,
    nth,
} from "lodash/fp";
import * as apis from "../../axios/PublicLink/index";
import { normalize, formatterPoint, getQueryVariable } from "../../utils/tools";
import {
    trackerConfig,
    PAGE_EXPOSE,
    BUTTON_CLICK,
    ELEMENT_EXPOSE,
} from "../../utils/bigDataSdk";
import * as config from '../../axios/config'
// import { parseAddress, signature } from "./utils";


const validPhone = (phone) => /^1[3-9]\d{9}$/.test(phone);
const validName = (name) => /^[\u4E00-\u9FA5A-Za-z]+$/gi.test(name);

export default {
    data() {
        return {
            isCatchGuide: true, // 是否为兜底导购
            name: "",
            nameInputing: false,
            phone: "",
            phoneInputing: false,
            verifyCode: "",
            codeInputing: false,
            sexCode: 1,
            checked: false,
            showSuccess: false,
            stage: 0,
            meta: {},
            uid: "",
            areaInputing: false,
            nameValidate: "",
            phoneValidate: "",
            codeValidate: "",
            accessKey: "", // 表单提交的key
            btnOptFlag: false,
            codeBtnText: '获取验证码',
            outTime: 60, // 设置发送验证码倒计时时间
            timer: null,
            tel: '',
            message: '',
            guideInfo: {},
            sourceType: ''
        };
    },

    created() {
    },

    mounted() {
        const query = this.$route.query || {};
        console.log(query);
        // 获取url参数
        const {
            longitude,
            latitude,
            unionId: unionId,
            openId: openId,
            networkId: networkId,
            guideId: guideId,
            gradeCode: gradeCode,
            sourceId: sourceId,
            sourceType: sourceType,
            subject: subject,
            sourceUrl: sourceUrl,
            linkId: linkId,
            qRCodeId: qRCodeId,
            isSignin: isSignin,
            subjectName,
            fromPage,
            firstNavi,
            submitDetail,
            channelCode,
            fromResourceId,
            fromResourceName,
            fromContent
        } = query;
        this.sourceType = sourceType
        if (sourceType === 'machine') {
            document.title = '购机咨询'
        } else {
            document.title = '课程咨询'
        }
        const base = {
            point: formatterPoint(longitude, latitude),
            unionId,
            linkId,
            networkId,
            openId,
            channelCode: channelCode || 'gylj'
        };

        this.base = base;

        this.meta = {
            ...base,
            subject: subject ? subject : '0',
            gradeCode,
            sourceUrl,
            sourceId,
            sourceType,
        };

        const guide = {
            unionId,
            networkId,
            point: formatterPoint(longitude, latitude),
            guideId,
            linkId,
            qRCodeId: qRCodeId ? qRCodeId : config.qRCodeId
        }
        console.log(22222, guide);
        apis.getRecommendUserInfo(guide).then(res => {
            if (res.errcode != 0) throw res.errmsg
            console.log(11111, res);
            this.guideInfo = res.data
            this.isCatchGuide = res.data.isDefaultGuide || false
        }).catch(err => {
            this.$toast(err)
        })
        console.log(fromPage);
        this.tracker = trackerConfig({
            pageName: "购机咨询页",
            pageId: "70006",
            isSignin: isSignin || null,
            fromPage: fromPage ? JSON.parse(fromPage) : null,
            firstNavi: firstNavi || null,
            subject: subjectName || null,
            submitDetail: submitDetail || null,
            fromResourceId: fromResourceId || null,
            fromResourceName: fromResourceName || null,
            fromContent: fromContent || null,
            fromButtonName: this.fromButtonName

        }, {
            app_key: '7bea62d8-928c-4ea1-997d-4f3217c0628a',
            appinfo: {
                _package_name: 'com.anoah.gylj',
                _platform_type: 'wxpub',
                _app_name: '公益链接',
            },
            deviceinfo: {
                _ProductID: '2022121410395012345'
            }
        });
        // setTimeout(()=>{
        this.tracker({
            eventKey: PAGE_EXPOSE,

        });
        // },200)
    },
    computed: {
        fromButtonName() {
            return this.sourceType === 'machine' ? '购机咨询' : '点击领取'
        },
        // 姓名和电话号码必填
        canSubmit() {
            return (
                !isEmpty(this.name) &&
                validPhone(this.phone) &&
                !isEmpty(this.verifyCode) &&
                isEmpty(this.nameValidate) &&
                this.checked
            );
        },
        config() {
            return {
                ...prop("$store.state.activity.config")(this),
                // applyTemplateCode: "1"
            };
        },
        sexDict() {
            return prop("$store.state.activity.config.sexDict.dictList")(this) || [];
        },
        sexDictMap() {
            return normalize(
                prop("$store.state.activity.config.sexDict.dictList")(this) || [],
                "code"
            );
        },
    },
    methods: {

        // 获取按钮埋点
        btnClick(type, event) {
            console.log(type, event);
            if (type === 'sex') {
                this.tracker({
                    eventKey: 'BUTTON_CLICK',
                    buttonName: this.sexCode == 1 ? '先生' : '女士',
                    sex: this.sexCode == 1 ? '男' : '女',
                    phone: this.phone || null,
                    verifyCode: this.verifyCode || null,
                    isAgree: this.checked ? 1 : 0,
                    fromButtonName: this.fromButtonName
                });
            } else {
                this.tracker({
                    eventKey: 'BUTTON_CLICK',
                    buttonName: '我同意',
                    sex: this.sexCode == 1 ? '男' : '女',
                    phone: this.phone || null,
                    verifyCode: this.verifyCode || null,
                    isAgree: this.checked ? 1 : 0,
                    fromButtonName: this.fromButtonName
                });
            }
        },
        // 获取焦点埋点
        getFocus(type) {
            if (type === 'name') {
                this.nameInputing = true
                this.tracker({
                    eventKey: 'INPUTBOX_CLICK',
                    inputboxName: '姓名',
                    sex: this.sexCode == 1 ? '男' : '女',
                    fromButtonName: this.fromButtonName
                });
            } else if (type === 'phone') {
                this.phoneInputing = true
                this.tracker({
                    eventKey: 'INPUTBOX_CLICK',
                    inputboxName: '手机号码',
                    sex: this.sexCode == 1 ? '男' : '女',
                    fromButtonName: this.fromButtonName
                });
            } else if (type === 'code') {
                this.codeInputing = true
                this.tracker({
                    eventKey: 'INPUTBOX_CLICK',
                    inputboxName: '验证码',
                    sex: this.sexCode == 1 ? '男' : '女',
                    fromButtonName: this.fromButtonName
                });
            }
        },
        // 打开隐私协议
        openLink() {
            window.open('https://youxueketang.anoah.com/yxp-page-manage/#/mobileContent?contentId=933')
        },
        // 获取验证码
        getVerifyCode() {
            if (isEmpty(this.phone)) {
                this.$toast('请输入手机号')
            } else if (!validPhone(this.phone)) {
                this.$toast('手机号格式不正确')
            } else if (validPhone(this.phone)) {
                if (this.btnOptFlag) return
                this.$toast.loading({
                    duration: 0, // 持续展示 toast
                    forbidClick: true,
                    message: "加载中",
                });
                this.btnOptFlag = true // 禁用发送验证码按钮
                apis.sendPhoneVerifyCode({ phone: this.phone }).then(res => {
                    if (!this.timer) {
                        this.$toast.clear()
                        this.timer = setInterval(() => {
                            this.codeBtnText = this.outTime + 's后重新发送'
                            this.outTime = this.outTime - 1
                            if (this.outTime < 0) {
                                // 倒计时结束，重置时间器clearInterval(this.timer)
                                clearInterval(this.timer)
                                this.codeBtnText = '获取验证码'
                                this.outTime = 60
                                this.timer = false
                                this.btnOptFlag = false
                            }
                        }, 1000)
                        // 每秒执行一次
                    }
                    this.tracker({
                        eventKey: 'BUTTON_CLICK',
                        buttonName: '验证码',
                        sex: this.sexCode == 1 ? '男' : '女',
                        phone: this.phone || null,
                        verifyCode: this.verifyCode || null,
                        isAgree: this.checked ? 1 : 0,
                        fromButtonName: this.fromButtonName
                    });
                })
            }
        },

        async onSubmit() {
            if (!this.checked) {
                this.$toast('请同意 《个人信息保护声明》')
                return
            }
            if (this.submiting) {
                return;
            } else {
                this.submiting = true;
            }
            if (!this.canSubmit) {
                this.submiting = false;
                return;
            }
            const baseMeta = {
                verifyCode: this.verifyCode,
                sexCode: this.sexCode,
                phone: this.phone,
                name: this.name,
                networkId: this.guideInfo.networkId,
                guideId: this.guideInfo.guideId
            };

            let meta = {
                ...this.meta,
                ...baseMeta,
            };
            this.$toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: "加载中",
            });
            this.tracker({
                eventKey: 'BUTTON_CLICK',
                buttonName: '立刻询价',
                sex: this.sexCode == 1 ? '男' : '女',
                phone: this.phone || null,
                verifyCode: this.verifyCode || null,
                isAgree: this.checked ? 1 : 0,
                fromButtonName: this.fromButtonName
            });
            apis.welfareApply(meta)
                .then(({ errcode, errmsg } = {}) => {
                    if (errcode != 0) {
                        return this.$toast({
                            message: errmsg,
                            type: "fail",
                        });
                    } else {

                        // this.showSuccess = true;
                        const queryParam = flow(
                            replace("/public-link/?", ""),
                            replace("/?", "")
                        )(this.$route.fullPath);
                        setTimeout(() => {
                            this.$router.push({
                                path: `/code?${queryParam}`,
                                query: {
                                    adviser: JSON.stringify(this.guideInfo)
                                }
                            });
                        }, 500);
                    }
                })
                .catch(({ errmsg } = {}) => {
                    this.$toast({
                        message: errmsg,
                        type: "fail",
                    });
                })
                .finally(() => {
                    this.$toast.clear();
                    this.submiting = false;
                });
        },
        requireIcon(props) {
            return require(`@/assets/radio${props.checked ? "_active" : ""}.png`);
        },
        nameValidateAction() {
            if (this.nameInputing && isEmpty(this.name)) {
                this.nameValidate = "姓名不能为空";
            } else if (this.nameInputing && !validName(this.name)) {
                this.nameValidate = "不能有特殊字符";
            } else {
                this.nameValidate = "";
            }
            this.tracker({
                eventKey: 'INPUTBOX_INPUT',
                inputboxName: '姓名',
                sex: this.sexCode == 1 ? '男' : '女',
                inputContent: this.name,
                fromButtonName: this.fromButtonName
            });
        },
        phoneValidateAction() {
            if (
                this.phoneInputing &&
                (isEmpty(this.phone) || !validPhone(this.phone))
            ) {
                this.phoneValidate = "请输入11位手机号";
            } else {
                this.phoneValidate = "";
            }
            this.tracker({
                eventKey: 'INPUTBOX_INPUT',
                inputboxName: '手机号码',
                sex: this.sexCode == 1 ? '男' : '女',
                inputContent: this.phone,
                fromButtonName: this.fromButtonName
            });
        },
        codeValidateAction() {
            if (this.codeInputing && isEmpty(this.verifyCode)) {
                this.codeValidate = "验证码不能为空";
            } else {
                this.codeValidate = "";
            }
            this.tracker({
                eventKey: 'INPUTBOX_INPUT',
                inputboxName: '验证码',
                sex: this.sexCode == 1 ? '男' : '女',
                inputContent: this.verifyCode
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.container {
    height: 100%;
    background: linear-gradient(90deg, #FBFBFC 0%, #F5F5F7 100%);
}

.bottom-text {
    padding: 10px 0;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    position: fixed;
    bottom: 0;
    height: 120px;
    width: 100%;
    display: flex;
    flex-direction: column;
    // align-items: center;                                                                                                                                                     
    font-size: 14px;
    font-weight: 400;
    justify-content: center;

    .desc {
        color: #999999;
        font-size: 12px;
        margin-left: 20px;
    }
}

.van-checkbox {
    margin-right: 10px;
}

.agree-statement {
    margin-left: 20px;
    display: flex;
    color: #666666;
    align-items: center;
}

.person-statement {
    color: #3875C6;
}

.verify-code {
    color: #3875C6;
}

.banner {
    width: 100%;

    .title {
        height: 40px;
        display: flex;
        align-items: center;
        margin-left: 30px;

        // justify-content: center;
        .price {
            font-weight: 600;
            color: #333333;
            font-size: 16px;
            margin-right: 16px;
        }

        .person-info {
            font-size: 14px;
            font-weight: 400;
            color: #666666;
        }
    }
}

.content {
    background: #ffffff;

    display: flex;
    flex-direction: column;

    .guide-box {
        margin: 10px 20px 20px 20px;
        padding: 10px;
        display: flex;
        height: 80px;
        align-items: center;
        background: linear-gradient(90deg, #FFF9F5 0%, #FFE6D1 100%);
        box-shadow: 0px 1px 5px 0px rgba(255, 240, 227, 0.35);
        border-radius: 8px;

        .guide-img {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            margin-right: 20px;
            // margin-left: 10px;
            overflow: hidden;
            background: url(../../assets/man-avatar.png);
            background-position: center center;
            background-size: 60px 60px;

            .avatar {
                // border-radius: 50%;
                height: 100%;
                // width: 100%;
            }
        }

        .guide-qrcode {
            width: 90px;
            height: 90px;
            margin-right: 20px;
        }

        .guide-right {
            flex: 1;

            .guide-name {
                font-size: 16px;
                font-weight: 600;
                color: #000000;
            }

            .guide-address {
                width: 90%;
                margin-top: 10px;
                font-size: 14px;
                font-weight: 400;
                color: #666666;
            }
        }
    }
}

.submit-wrapper {
    // width: 100%;
    // box-sizing: border-box;
    margin: 10px 20px 8px 20px;

    /deep/ .van-button--normal {
        font-size: 16px;
        font-weight: 400;
        color: #666666 !important;
    }

    // padding: 0 20px 40px;
}

.submit {
    width: 100%;
}

.succeed {
    width: 130px;
    height: 130px;
    background: #ffffff;
    border-radius: 12px;
    text-align: center;
    padding-top: 18px;
    box-sizing: border-box;

    .icon {
        widows: 50px;
        height: 58px;
    }

    .hint {
        margin-top: 17px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #34404a;
    }
}

.grade-list {
    display: flex;
    padding: 0 24px;
    justify-content: space-between;
    flex-wrap: wrap;
}

.grade-list:last-child {
    padding-bottom: 21px;
}

.grade {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 34px;
    width: calc((100% - 24px) / 3);
    height: 34px;
    text-align: center;
    background: #f5f5f7;
    border: 1px solid #f5f5f7;
    border-radius: 6px;
    margin-bottom: 8px;
}

.grade.active {
    color: #456fee;
    border: 1px solid #456fee;
}

.van-cell {
    padding: 21px 24px;
    align-items: center;
}

.name-input {
    padding: 0;
}

.radio-icon {
    width: 16px;
    height: 16px;
}

.black {
    color: #333;
}

.label {
    // display: flex;
    // align-items: center;
    color: #333333 !important;
    font-weight: bold;
    display: flex;
    align-items: center;
}

.label-box {
    display: flex;
    align-items: center;
}

.label:after {
    content: ' *';
    color: red;
    font-size: 22px;
    // line-height: 22px;	
    margin-top: 8px;
    margin-left: 4px;
}

.radio {
    font-weight: bold;
    color: #333;
}

.grad-radio {
    margin-right: 0;
    margin-left: 27.5px;
}

.grad-radio:first-child {
    margin-left: 0;
}

.six-radio {
    margin-right: 0;
}

.six-radio:last-child {
    margin-left: 12.5px;
}

.grade-title {
    width: 100px;
    flex: initial;
}

.grade-radio-wrap {
    justify-content: space-between;
    flex: auto;
}

.placeholder {
    color: #999999;
}

.empty-placeholder {
    height: 20px;
    width: 100%;
}

.error {
    color: #ee0a24;
}

// 屏幕宽度小于350时适配
@media screen and (max-width: 374px) {
    .six-radio:last-child {
        margin-left: 7px;
    }

    .grad-radio {
        margin-left: 7px;
    }

    .van-field__label {
        width: 60px !important;
    }

    .van-cell {
        padding: 21px 10px;
        align-items: center;
    }

    .grade-list {
        padding: 0 10px;
    }

    .submit-wrapper {
        padding: 0 10px 40px;
    }

    .name-input {
        padding: 0;
    }
}
</style>
